import axios from 'axios';

import { BaseUrl } from '../consts';
import { getAuthHead } from '../helpers/authHelper';

export const getPermissions = async () => {
    const auth = await getAuthHead();
    return await axios.get(`${BaseUrl}security/user/authorization`, auth);
};
